// Display the original blue artwork consistently in the header and sidebar.
export const timelyIconStyle = {
  background: 'url("/images/timely365-icon.png") center / contain no-repeat',
};
